import {
  postCall,
  genericPostCall,
  genericGetCall,
} from "../../utils/apiCalls";
import {
  RATINGS_LIST,
  FILTER_RATINGS_LIST,
  OPERATOR_DASHBOARD_RATINGS,
  SORT_DATA_BY,
  ROUTE_RATINGS_DETAILS,
  CHANGE_VIEW,
  V2_SOURCE_CITIES,
  V2_DEST_CITIES,
  UNREVIEWED_LIST,
  SHOW_ASK_FOR_REVIEWS
} from "./actionTypes";
import {
  GET_RATING_LIST,
  GET_OPERATOR_DASHBOARD_RATINGS,
  GET_ROUTE_RATINGS_DETAILS,
  FETCH_V2_CITIES,
  GET_UNREVIEWED_ORDERS,
  NOTFICATION_URL,
} from "../../config/urls";
import BaseURL, { BusInternal, BaseCoreURL } from "../../config";


export const ratingInformationList = (query, isNewQuery) => dispatch => {
  const data = {
    "offset": 10 * (query.pageNo - 1),
    "limit": 10,
    "source": query.source,
    "destination": query.destination,
    "service": query.service
    }
  postCall(GET_RATING_LIST, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      // temp
      if (res && res.data && res.data.code === 200) {
        dispatch({
          type: RATINGS_LIST,
          payload: res.data || [],
          isNewQuery
        })
      } else {
        alert('Error, Please try again.');
      }
    })
}

export const getUnReviewedOrders =
  (query = {}, isNewQuery, cb = () => {}) =>
  (dispatch) => {
    const params = {
      offset: 10 * (query.pageNo - 1),
      limit: 10 * query.limit,
      paytm_src_id: query.paytm_src_id,
      paytm_dest_id: query.paytm_dest_id,
    };

    genericGetCall(BaseURL + GET_UNREVIEWED_ORDERS, params, ["merchant"]).then((res) => {
      if (res && res.data && res.data.code === 200) {
        dispatch({
          type: UNREVIEWED_LIST,
          payload: res.data.body || [],
          isNewQuery,
        });
        cb(true);
      } else {
        alert("Error, Please try again.");
        cb(false);
      }
    });
  };

  export const toggleAskForReviews =
    (query = {}) =>
    (dispatch) => {
      dispatch({
        type: SHOW_ASK_FOR_REVIEWS,
        payload: query,
      });
    };

export const sendNotification = (query, isNewQuery) => async (dispatch) => {
  const { type } = isNewQuery || {};
  try {
    const res = await postCall(NOTFICATION_URL, { ...query, __essentialParams__: ["merchant"] });

    let notificationStatus = false;
    console.log('res =>', res);

    if (res && res.data && res.data.code === 200) {
      notificationStatus = true;
      if (type === "whatsapp" || type === "email") {
        alert("Successfully Sent Notification");
      }
    } else {
      const { message } = res.response.data || {};
      alert(message || "Error, Please try again.");
    }

    return notificationStatus;
  } catch (error) {
    console.error("Error in sendNotification:", error);
    return false;
  }
};

export const filterRatingsList = (query, isNewQuery) => dispatch => {
  dispatch({
    type: FILTER_RATINGS_LIST,
    query
  })
}

export const getOperatorDashboardRatings = (data, isNewQuery) => dispatch => {
  genericPostCall(BusInternal + GET_OPERATOR_DASHBOARD_RATINGS, { ...data, __essentialParams__: ['merchant'] })
    .then(res => {
      if (res && res.status === 200) {
        // in case of no meta details
        if (!res.data.content) return;

        dispatch({
          type: OPERATOR_DASHBOARD_RATINGS,
          payload: res.data || [],
        })
      } else
        alert('Error, Please try again.');
    })
}
export const sortDataBy = (query, isNewQuery) => dispatch => {
  dispatch({
    type: SORT_DATA_BY,
    query
  })
}

export const getRouteRatingsDetails = (data, isNewQuery) => dispatch => {
  let { params } = data;
  genericGetCall(BusInternal + GET_ROUTE_RATINGS_DETAILS, params, ['merchant'])
    .then(res => {
      if (res && res.status === 200) {
        // in case of no meta details
        if (!res.data.content) return;
        let payload = { ...res.data, data }
        dispatch({
          type: ROUTE_RATINGS_DETAILS,
          payload
        })
      } else
        alert('Error, Please try again.');
    })

}

export const changeView = (query, isNewQuery) => dispatch => {
  dispatch({
    type: CHANGE_VIEW,
    query
  })
}

export const getV2Cities = (query, fieldType) => (dispatch) => {
  let city = query && encodeURIComponent(query);
  let url = `${BaseCoreURL}${FETCH_V2_CITIES}/${city}}`;
  genericGetCall(url, {}, ['merchant']).then((res) => {
    if (res && res.status === 200) {
      let payload = res.data;
      dispatch({
        type: fieldType === 'source' ? V2_SOURCE_CITIES : V2_DEST_CITIES,
        payload,
      });
    } else alert("Error, Please try again.");
  });
};

